
import React from "react";
import IntFileLogList from "../component/IntFileLogList";

const IntFileLogListContainer = ({ pageId }) => (<IntFileLogList pageId={ pageId}/>)

export default IntFileLogListContainer;